<template>
  <div class="contactWrap" id="page9">
    <div class="contactTop">
      <button @click="showForm">立即体验</button>
    </div>
    <div class="contactBottom">
      <div class="link1">
        <!-- <img src="../assets/images/logo.png" /> -->
        <span style="font-size: 16px;">涿溪防窜货</span>
        <div class="imgsWrap">
          <div>
            <div class="codeWrap">
              <h4>微信公众号</h4>
              <label>请扫描二维码</label>
              <img src="../assets/images/gzh_code.jpg" class="codeImg" />
              <!-- <vue-qr :logoScale="20" :text="codeValue" :margin="0" :dotScale="1" :size="size"></vue-qr> -->
            </div>
          </div>
          <div>
            <a href="https://weibo.com/u/7673015102" target="_blank" class="wb_link"></a>
          </div>
          <!--<div></div>
          <div></div> -->
        </div>
      </div>
      <!-- <div class="link2">
        <h6>导航</h6>
        <ul>
          <li>产品</li>
          <li>解决方案</li>
          <li>行业趋势</li>
          <li>客户案例</li>
          <li>认识我们</li>
        </ul>
      </div> -->
      <div class="link3">
        <h6>友情链接</h6>
        <ul>
          <li><a href="https://www.citln.cn/" target="_blank">国家顶级节点服务平台</a></li>
          <li><a href="http://www.caict.ac.cn/" target="_blank">中国信通院</a></li>
          <li><a href="https://www.miit.gov.cn/" target="_blank">工业和信息化部</a></li>
        </ul>
      </div>
      <div class="link4">
        <h6>联系我们</h6>
        <ul>
          <li>Tel：13048079186</li>
          <li>公司地址：广州市花都区新华街凤华路2-2</li>
        </ul>
      </div>
    </div>
    <div class="pageFooter">版权所有 © 涿溪（广州）日化科技发展有限公司<br /> 晋ICP备20004698号-2</div>
  </div>
</template>
<script>
import vueQr from 'vue-qr'
export default {
  name: 'codeContact',
  data () {
    return {
      codeValue: 'https://weibo.com/u/7673015102',
      size: 120,
    }
  },
  components:{
   vueQr
  },
  methods:{
    showForm() {
      this.$emit('changeVisible', true)
    }
  }
}
</script>
<style scoped lang="scss">
.codeWrap{
  top: -230px;
  left: -80px;
  width: 144px;
  height: 200px;
  padding: 16px 12px 2px;
  text-align: center;
  display: none;
  position: absolute;
  box-shadow: 0 6px 18px 0 #eee;
  background-color: #fff;
  z-index: 1000;
  font-size: 14px;
  .codeImg{
    width: 120px;
    height: 120px;
  }
  h4 {
    color: #383838;
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 12px;
    font-family: inherit;
    line-height: 1.1;
  }
  label{
    color: #a6a6a6;
    font-size: 14px;
    margin-bottom: 12px;
    display: inline-block;
    max-width: 100%;
    font-weight: 700;
  }
}

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
}
a {
  color: inherit;
  text-decoration: none;
}
a:hover{
  color: #6D3B96;
}
.link1{
  font-size: 14px;
  padding-top: 55px;
  .imgsWrap{
  padding-top: 40px;
  display: flex;
  // width: 125px;
  width: 80px;
  flex-direction: row;
  justify-content: space-around;
  // justify-content: space-between;
  >div {
    width: 28px;
    height: 28px;
    position: relative;
    &:hover{
      .codeWrap{
        display: block;
      }
    }
    &:nth-child(1) {
      background: url('../assets/images/wx.png') top left no-repeat;
      &:hover{
        background: url('../assets/images/wx2.png') top left no-repeat;
      }
    }
    &:nth-child(2) {
      background: url('../assets/images/wb.png') top left no-repeat;
      &:hover{
        background: url('../assets/images/wb2.png') top left no-repeat;
      }
    }
    &:nth-child(3) {
      background: url('../assets/images/dy.png') top left no-repeat;
      &:hover{
        background: url('../assets/images/dy2.png') top left no-repeat;
      }
    }
    &:nth-child(4) {
      background: url('../assets/images/tt.png') top left no-repeat;
      &:hover{
        background: url('../assets/images/tt2.png') top left no-repeat;
      }
    }
  }
}
}

.wb_link{
  width: 28px;
  height: 28px;
  display: inline-block;
}
.contactWrap{
  .contactTop{
    width: 100%;
    height: 320px;
    text-align: center;
    background: url('../assets/images/talk.png') top left no-repeat;
    background-position: top center;
    background-size:cover;
    > button {
      margin-top: 200px;
      font-size: 18px;
      font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 25px;
      border-radius: 38px;
      border: 1px solid #fff;
      padding: 12px 45px;
      background-color: transparent;
    }
  }
  .contactBottom{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 10px 0 30px 0;
    h6 {
      font-size: 16px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: normal;
      color: #1F2329;
      line-height: 22px;
      margin: 55px 0 20px;
      cursor: pointer;
      &:hover{
        color: #6D3B96;
      }
    }
    li{
      font-size: 14px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: normal;
      color: #6C7480;
      line-height: 20px;
      padding-bottom: 12px;
    }
  }
  .pageFooter{
    background: #F2F4F6;
    text-align: center;
    font-size: 12px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #6C7480;
    line-height: 17px;
    padding: 26px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CodeContact.vue